import classNames from 'classnames';

import { dateFormat, timeFormat } from 'common/helpers/dateHelper';
import { getCurrency } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

const ReservationSummary = (props) => {
  const { reservationCart, isSummaryVisibleOnMobile, settings } = props;
  const item = {
    price: reservationCart.price
  };

  if (reservationCart.virtualCart) {
    item.price = reservationCart.virtualCart.items[0].price;
    item.comparePrice = reservationCart.virtualCart.items[0].comparePrice;
    item.itemData = reservationCart.virtualCart.items[0].itemData;
  }
  return (
    <section
      className={classNames(
        'c7-checkout-summary',
        isSummaryVisibleOnMobile && 'c7-visible'
      )}
    >
      <h2>Reservation Summary</h2>
      <h3>{reservationCart.reservationType.title}</h3>
      {renderContent(reservationCart.reservationType)}
      <hr />

      <h3>Reservation Information</h3>
      <div className="c7-checkout-summary__reservation-items">
        <div>
          <span>Reservation:</span>
          {reservationCart.reservationType.title}
        </div>
        <div>
          <span>Option:</span>
          {reservationCart.reservationTypeOption.title}
        </div>
        <div>
          <span>Date:</span>
          {dateFormat(reservationCart.reservationDate, settings)}
        </div>
        <div>
          <span>Time:</span>
          {timeFormat(reservationCart.reservationDate, settings)}
        </div>
        <div>
          <span>Guest(s):</span>
          {reservationCart.guestCount}
        </div>
        <div>
          <span>Price:</span>
          <ItemPrice settings={settings} item={item} />
        </div>
        <div>
          <span>Subtotal:</span>
          {getCurrency(settings)}
          {currencyFormat(item.price * reservationCart.guestCount, settings)}
          <PointsSummary item={item} reservationCart={reservationCart} />
        </div>
      </div>
    </section>
  );
};

export default ReservationSummary;

const renderContent = (reservationType) => (
  <div dangerouslySetInnerHTML={{ __html: reservationType.content }} />
);

const ItemPrice = (props) => {
  const { item, settings } = props;
  if (item.comparePrice > item.price) {
    return (
      <>
        <span className="c7-checkout-summary__strikethrough">
          {currencyFormat(item.comparePrice, settings)}
        </span>
        {currencyFormat(item.price, settings)} / person
        <Points item={item} />
      </>
    );
  }
  return (
    <>
      {currencyFormat(item.price, settings)} / person <Points item={item} />
    </>
  );
};

const Points = (props) => {
  const { item } = props;
  if (item.itemData?.loyaltyPoints) {
    return (
      <>
        <br />
        <span>&nbsp;</span>
        {item.itemData.loyaltyPoints} Points
      </>
    );
  }
  return null;
};

const PointsSummary = (props) => {
  const { item, reservationCart } = props;
  if (item.itemData?.loyaltyPoints) {
    return (
      <>
        <br />
        <span>&nbsp;</span>
        {item.itemData.loyaltyPoints * reservationCart.guestCount} Points
      </>
    );
  }
  return null;
};
